import React, { Component } from "react";

interface IProps {
	disabled: boolean;
	controllerClass: string;
	controllerValue: any;

	clickFunction: (e: React.MouseEvent) => void;

	useHDImage?: boolean;
	HDImagePrefix?: string;

	//Desktop only
	pcode?: string;
}

export default class GameController extends Component<IProps> {
	state = { pressed: false }

	render() {
		return (
			<button
				onClick={this.props.clickFunction}

				onMouseDown={() => { this.setState({ pressed: true }) }}
				onMouseUp={() => { this.setState({ pressed: false }) }}
				onMouseLeave={() => { this.setState({ pressed: false }) }}

				{...{ pcode: this.props.pcode }}
				className={
					this.props.useHDImage ? null :
						this.props.controllerClass}
				disabled={this.props.disabled}>

				{
					this.props.useHDImage ? (
						<>
							<img src={
								"assets/img/hd_buttons/" +
								this.props.HDImagePrefix +
								(this.state.pressed ? "_pressed" : "") +
								".png"} />

							<div className="label">
								{this.props.controllerValue}
							</div>
						</>
					) : this.props.controllerValue
				}
			</button>
		);
	}
}